import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=96b04722&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"
import style0 from "./apply.vue?vue&type=style&index=0&id=96b04722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b04722",
  null
  
)

export default component.exports